import { render, staticRenderFns } from "./formRegion.vue?vue&type=template&id=cf8cb90e&scoped=true&"
import script from "./formRegion.vue?vue&type=script&lang=js&"
export * from "./formRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8cb90e",
  null
  
)

export default component.exports